import React from 'react'
import MerchantLogoForm from '../MerchantLogoForm'
import MerchantCollectionsAddForm from '../MerchantCollectionsAddForm'
import Categories from './Categories'

const MerchantLogo = () => {
  return (
    <div className="container mt-3 ps-0 pe-0 ps-lg-2">
        <div id="accordion">
            <div className="card">
            <div className="card-header" htmlFor="UploadStoreDetails">
                <a className="" data-bs-toggle="collapse" href="#collapseOne" style={{textDecoration:"none",color: "#000"}} id='UploadStoreDetails'>
                    Upload Store Details
                </a>
            </div>
            <div id="collapseOne" className="collapse show" data-bs-parent="#accordion">
                <div className="card-body p-0">
                    <MerchantLogoForm/>
                </div>
            </div>
            </div>
            <div className="card">
            <div className="card-header">
                <a className="collapsed" data-bs-toggle="collapse" href="#collapseTwo" style={{textDecoration:"none",color: "#000"}}>
                    Add Categories
                </a>
            </div>
            <div id="collapseTwo" className="collapse" data-bs-parent="#accordion">
                <div className="card-body p-0"> 
                    <Categories/>
                </div>
            </div>
            </div>
            <div className="card" >
            <div className="card-header">
                <a className="collapsed" data-bs-toggle="collapse" href="#collapseThree" style={{textDecoration:"none",color: "#000"}}>
                    Add New Products
                </a>
            </div>
            <div id="collapseThree" className="collapse" data-bs-parent="#accordion">
                <div className="card-body p-0"> 
                    <MerchantCollectionsAddForm/>
                </div>
            </div>
            </div>
            
        </div>
    </div>
  )
}

export default MerchantLogo